import React from "react";
import { MessageCircle } from "lucide-react";

interface RegisterHeaderProps {
  title?: string;
  subtitle?: string;
}

export const RegisterHeader: React.FC<RegisterHeaderProps> = ({
  title = "Criar conta Easyfit",
  subtitle = "Cadastro seguro com PagBank",
}) => {
  return (
    <header className="flex-shrink-0 bg-purple-600 px-3 py-3 text-white md:px-4 md:py-4 lg:bg-white lg:text-gray-900 lg:dark:bg-gray-900 lg:dark:text-white">
      <div className="flex items-center gap-3">
        <div className="flex h-9 w-9 items-center justify-center rounded-full bg-purple-500 lg:h-10 lg:w-10">
          <MessageCircle className="h-[18px] w-[18px] lg:h-5 lg:w-5" />
        </div>
        <div className="min-w-0 flex-1">
          <h1 className="truncate text-sm font-semibold md:text-base lg:text-lg">
            {title}
          </h1>
          <p className="text-[11px] text-purple-100 md:text-xs lg:text-gray-500 lg:dark:text-gray-400">
            {subtitle}
          </p>
        </div>
      </div>
    </header>
  );
};

export default RegisterHeader;

